<template>
  <button
   class="button pa-additional-button pa-park-manage-invitation-button"
   @click.prevent="handleClickManageInvitation"
  >招待コードの管理</button>
</template>

<script>
export default {
  methods : {
    handleClickManageInvitation(){
      const newUrlQuery = Object.assign({}, this.$route.query);

      newUrlQuery['open_invitation_manage_modal'] = 'yes';
      newUrlQuery['y'] = window.scrollY;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    }
  }
}
</script>

<style lang="scss">
button.pa-park-manage-invitation-button{
  background-color:#C8AD8D;
  color:#867057;
  border:0;
  padding:.6rem .4rem;
  margin:.5rem .5rem 0 0;
  line-height:1;
  font-size:.7rem;
  height:auto;

  &:hover, &:active, &:focus{
    color: #867057;
    background-color: #C8AD8D;
    border:0;
  }

  &:focus{
    box-shadow:none;
  }
}
</style>